module.exports = __webpack_public_path__ + "img/nav-bg-md.2caf6a8a.png";